var modules_2529eb59 = {"layout":"Footer_module_layout__bb63ccef","containerBgColor-primary":"Footer_module_containerBgColorPrimary__bb63ccef","containerBgColor-secondary":"Footer_module_containerBgColorSecondary__bb63ccef","appBanner":"Footer_module_appBanner__bb63ccef","storesBanner":"Footer_module_storesBanner__bb63ccef","contactsBanner":"Footer_module_contactsBanner__bb63ccef"};
import "../../../assets/Ci9cJNkP.css";

export { modules_2529eb59 as default };
//# sourceMappingURL=Footer.module.less.js.map
